import {
    UWM_AMPLITUDE_TRACKING,
    UWM_MODULE_BACK_BUTTON_CLICK,
    UWM_MODULE_DATA_RECEIVED_SUCCESS,
    UWM_MODULE_GET_EXTERNAL_LINKS,
    UWM_MODULE_HIDE_MENU,
    UWM_MODULE_INITIALIZATION_ERROR,
    UWM_MODULE_LOADED,
    UWM_MODULE_REFETCH_DATA_REQUEST,
    UWM_MODULE_SCROLL,
    UWM_MODULE_SHOW_MENU,
} from '@/consts/eventTypes';

type EventMessagePayload = {
    type: string;
    [key: string]: unknown;
};

const sendMessageToParent = (payload: EventMessagePayload) => {
    window.parent.postMessage(
        {
            detail: {
                command: 'UwmEvent',
                payload: payload,
            },
        },
        '*'
    );
};

const sendLoadedMessageToParent = () => {
    sendMessageToParent({
        type: UWM_MODULE_LOADED,
    });
};

const sendDataSuccessReceivedMessage = () => {
    sendMessageToParent({
        type: UWM_MODULE_DATA_RECEIVED_SUCCESS,
    });
};

const sendModuleInitializationError = (message: string) => {
    sendMessageToParent({
        type: UWM_MODULE_INITIALIZATION_ERROR,
        message,
    });
};

const sendBackButtonTriggerMessage = () => {
    sendMessageToParent({
        type: UWM_MODULE_BACK_BUTTON_CLICK,
    });
};

const sendScrollMessage = (delta: number, scrollTop: number) => {
    sendMessageToParent({type: UWM_MODULE_SCROLL, delta, scrollTop} as EventMessagePayload & {
        delta: number;
        scrollTop: number;
    });
};

const trackAmplitude = (eventType?: string) => {
    if (!eventType) return;

    sendMessageToParent({
        type: UWM_AMPLITUDE_TRACKING,
        eventType,
    });
};

const sendShowMenu = () => {
    sendMessageToParent({type: UWM_MODULE_SHOW_MENU});
};

const sendHideMenu = () => {
    sendMessageToParent({type: UWM_MODULE_HIDE_MENU});
};

const sendGetExternalLinks = (externalLinks: Array<Record<string, unknown>>, isRefetch?: boolean) => {
    sendMessageToParent({
        type: UWM_MODULE_GET_EXTERNAL_LINKS,
        externalLinks,
        isRefetch,
    });
};

const sendRefetchDataRequest = () => {
    sendMessageToParent({type: UWM_MODULE_REFETCH_DATA_REQUEST});
};

export default {
    sendMessageToParent,
    sendLoadedMessageToParent,
    sendDataSuccessReceivedMessage,
    sendModuleInitializationError,
    sendBackButtonTriggerMessage,
    sendScrollMessage,
    sendShowMenu,
    sendHideMenu,
    trackAmplitude,
    sendGetExternalLinks,
    sendRefetchDataRequest,
};
